import { useEffect } from 'react';
import { useSnapshot } from 'valtio';
import store from '../store';

interface UseShouldOpenProps {
  layerIds?: string[];
  setIsOpen: (open: boolean) => void;
}

export const useShouldOpen = ({ layerIds, setIsOpen }: UseShouldOpenProps) => {
  const { selectedFeature, intelligenceFeatures } = useSnapshot(store) as typeof store;
  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  return useEffect(() => {
    if (selectedFeature?.id && layerIds) {
      const ids = new Set(layerIds);
      const featureId = selectedFeature.id?.toString();
      if (featureId) {
        const intel = intelligenceFeatures[featureId];
        if (intel?.layerId) {
          if (ids.has(intel.layerId)) {
            setIsOpen(true);
          }
        }
      }
    }
  }, [selectedFeature]);
};
